import { graphql, useStaticQuery } from 'gatsby'

export const getPrimaryFocusTerms = () => {
  const data = useStaticQuery(graphql`
    query {
      primaryFocusTerms: allTaxonomy(filter: { primaryFocus: { ne: null } }) {
        edges {
          node {
            title
            slug
            primaryFocus
          }
        }
      }
    }
  `)
  return data.primaryFocusTerms.edges
}
